let featureCollectionCarousel = new Swiper('[data-bt-featured-collection-carousel]', {
    slidesPerView: 2.5,
    spaceBetween: 10,
    freeMode: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    breakpoints: {
        768: {
            slidesPerView: 4,
            spaceBetween: 16,
            freeMode: false
        }
    }
})

let init = false;
let brandLogoCarousel;
function mobileCarouselInit() {
  if (window.innerWidth <= 767) {
    if (!init) {
      init = true;
      brandLogoCarousel = new Swiper("[data-brand-logo-carousel]", {
        slidesPerView: 2.5,
        spaceBetween: 10,
        freeMode: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },        
      });
    }
  } else if (init) {
    brandLogoCarousel.destroy();
    init = false;
  }
}
mobileCarouselInit();
window.addEventListener("resize", mobileCarouselInit);